"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = rulesApi;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _axios = _interopRequireDefault(require("axios"));
var _settings = require("../settings");
var _camelCase = _interopRequireDefault(require("../utils/camelCase"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function rulesApi(dataObject, immediateOnly) {
  var data = _objectSpread(_objectSpread({}, dataObject), {}, {
    executeRuleSet: immediateOnly ? 'immediate' : 'all'
  });
  var _getSettings = (0, _settings.getSettings)(),
    executeRulesApi = _getSettings.executeRulesApi;
  if (typeof executeRulesApi === 'string') {
    return (0, _axios["default"])({
      data: data,
      url: executeRulesApi,
      method: 'POST',
      crossDomain: true,
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (response) {
      return (0, _camelCase["default"])(response.data);
    }, function (err) {
      console.log(err); // eslint-disable-line no-console
      return Promise.reject(err);
    });
  } else if (typeof executeRulesApi === 'function') {
    return executeRulesApi(data).then(function (response) {
      return (0, _camelCase["default"])(response.data);
    });
  }
  return Promise.resolve({
    data: {
      optionDetails: [],
      messages: [],
      invokedRules: [],
      disabledOptions: [],
      disabledChoices: [],
      selectedChoices: [],
      summaryMessages: []
    },
    messages: []
  });
}
//# sourceMappingURL=rulesApi.js.map